import React from 'react'
import { Button, Text } from '@boulevard/blvd-ui'
import { appRootStore } from '../stores'
import { IBlvdFbIntegration } from '../types'

interface ProfileProps {
  blvdFbIntegration: IBlvdFbIntegration
  logo: any
  name: string
  caption: string
  showButton: boolean
}

export const Profile: React.FC<ProfileProps> = props => {
  const integrationsStore = appRootStore.getIntegrationsStore()

  return (
    <div className="card-menu-row-block">
      <div className="card-menu-left-side-block">
        <div className="card-menu-icon-block">
          <img src={props.logo} className="margin-b_20" alt="waiting" />
        </div>
        <span className="card-menu-text-block">
          <Text theme="muted" alignment="left" weight="light" fontFamily="default" as="div" variant="size4">{props.caption}</Text>
          <Text
                weight="bold"
                theme='default'
                alignment="left"
                fontFamily="default"
                as="div"
                variant="size5"
          >
            {props.name}
          </Text>
        </span>
      </div>
      {props.showButton && <Button
        theme="tertiary"
        padding="standard"
        type="button"
        size="medium"
        contentAlignment="center"
        onClick={() => integrationsStore.setIntegrationToDelete(props.blvdFbIntegration)}
      >
        Remove
      </Button>}
    </div>
  )
}
